// Root route — the header (MainNav) above every page, toasts, and focus
// management on navigation (the page <h1> receives focus for screen readers).

import { createRootRouteWithContext, Outlet, useRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { MainNav } from '@/components/layout/MainNav';
import { useFocusOnRoute } from '@/lib/a11y';
import { ToastProvider } from '@/lib/toast';

export interface RouterContext {
  queryClient: QueryClient;
}

function RootLayout(): JSX.Element {
  const router = useRouter();
  useFocusOnRoute(router);
  return (
    <ToastProvider>
      <div className="flex min-h-screen flex-col bg-bg">
        <MainNav />
        <div className="flex flex-1 flex-col">
          <Outlet />
        </div>
      </div>
    </ToastProvider>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});
